import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IPublishedConnection } from '../types/IPublishedConnection';

export interface IGetPublishedConnectionsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionsResult extends IGetItemsResult {
  publishedConnections?: IPublishedConnection[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionsRequest extends Request<IGetPublishedConnectionsParams, IGetPublishedConnectionsResult> {
  constructor(params: IGetPublishedConnectionsParams) {
    super('getPublishedConnections', params);
  }
}
